'use client';

import { createContext } from 'react';
/**
    This is a temporary context that indicated whether the content has been already centrally
    filtered (as currently the case in the preview) or still needs some filtering on
    component level (cms content).
  */
export const ContentAlreadyFilteredContext = createContext(false);
